import React from "react";
import "./UserInfo.scss";

import Flag from "src/app/components/Flag/Flag";
import personImage from "src/images/person.svg";
import { Img } from "src/app/components/Img/Img";
import MultipleSocialProviders from "../../../../components/MultipleSocialProviders/MultipleSocialProviders";

export default function UserInfo({ userData, creatorSearchSelectedProviders }) {
  const { gender, age, country, city } = userData;

  return (
    <div className="profile-data-pane__user-info">
      <div className="profile-data-pane__user-info__img">
        <Img
          className="profile-data-pane__user-info__img"
          src={userData.profilePictureUrl}
          fallbackImageSrc={personImage}
        />
        {userData.country && <Flag countryCode={userData.country} />}
      </div>
      <div className="profile-data-pane__user-info__data">
        <div className="profile-data-pane__user-info__header">
          {userData?.name ?? userData.username}
        </div>
        <div className="profile-data-pane__user-info__subheader">
          <span>
            {gender === 2 && "Female"} {gender === 1 && "Male"}
            {age > 0 && `, ${age}`}
          </span>
          <span>
            {city !== null && city !== "-" && `${city},`} {country}
          </span>
        </div>
        <MultipleSocialProviders
          currentSocialProvider={userData.socialProvider}
          socialProviders={userData.socialProviders}
          creatorSearchSelectedProviders={creatorSearchSelectedProviders}
        />
      </div>
    </div>
  );
}
